const labelColor = ({
  inMonth,
  isToday,
  isAvailable,
  theme: { main, darkGrey, lightGrey },
  todayColor = main
}) => {
  if (isToday) {
    return todayColor
  } else if (!isAvailable) {
    return lightGrey
  } else if (inMonth) {
    return darkGrey
  }
  return lightGrey
}

const isSelectedStyles = (isSelected, color) => {
  if (isSelected) {
    return `
      max-height: 33px;
      border-radius: 50%;
      background-color: ${color};
      color: white;
      transition: background-color  0.3s ease-in-out, color  0.3s ease-in-out;
    `
  }
}

export { isSelectedStyles, labelColor }



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/calendarHelpers.js